import { useState } from "react";

import { useSetup } from "../../SetupLife.context";
import { IBenefitsPolicy, BenefitsPolicyType, ICapitalInsured } from "../../SetupLife.types";

import { ButtonDelete, Container, RadioCard, Row, SelectForm, Title, Wrapper, WrapperButton } from "./BenefitsPolicy.styled";

import { BenefitsPolicyRegion } from "./BenefitsPolicy.Region";
import { BenefitsPolicyRole } from "./BenefitsPolicy.Role";
import { Button, MenuItem } from "@mui/material";
import { BenefitsPolicyUnique } from "./BenefitsPolicy.Unique";
import { TextField } from "../Rules/Rules.styled";

export function BenefitsPolicy() {
  /** Values needed to change the global state */
  const { setup, updateSetup } = useSetup();

  /** Estado local que possui todos os campos de regra de contrato. */
  const [benefitsPolicy, setBenefitsPolicy] = useState<IBenefitsPolicy>(setup.benefitsPolicy);
  const [capitalInsured, setCapitalInsured] = useState<ICapitalInsured[]>(setup.capitalInsured);

  /** Função responsável por validar e salvar as edições feitas nos campos de políticas de benefício. */
  async function handleSave() {
    try {
      //validar...
      updateSetup({ ...setup, benefitsPolicy: benefitsPolicy, capitalInsured: capitalInsured });
    } catch (error) {
      console.error(error);
    }
  }

  /** Função responsável por editar os campos de políticas de benefício. */
  async function handleChangeRoles(payload: Partial<IBenefitsPolicy>) {
    const updatedBenefitsPolicyFields = { ...benefitsPolicy, ...payload };

    return setBenefitsPolicy(updatedBenefitsPolicyFields);
  }

  async function handleAddNegotiation() {
    const negotiationId = String(Math.floor(Math.random() * 900000) + 100000);
    const newCapitalInsured = {
      negotiationId,
      tipoCapital: "VALOR_UNIFORME",
      escalonado: { grupos: []},
      faixaEtaria: {},
      multiploSalarial: {},
      valorUniforme: {},
    };

    setCapitalInsured([ ...capitalInsured, newCapitalInsured ]);
    return setBenefitsPolicy({ ...benefitsPolicy, negotiations: [...benefitsPolicy.negotiations, negotiationId] });
  }

  async function handleRemoveNegotiation(negotiationId: string) {
    const updatedNegotiations = benefitsPolicy.negotiations.filter((n) => n !== negotiationId);
    const updatedCapitalInsured = capitalInsured.filter((c) => c.negotiationId !== negotiationId);

    // Remove benefitsPolicyByRole associados com essa negociação
    const updatedBenefitsPolicyByRole = benefitsPolicy.benefitsPolicyByRole.filter(
      (b) => b.planName !== negotiationId
    );

    // Remove benefitsPolicyByGeographicRegion associados com essa negociação
    const updatedBenefitsPolicyByGeographicRegion = benefitsPolicy.benefitsPolicyByGeographicRegion.filter(
      (b) => b.planName !== negotiationId
    );

    // Limpa benefitsPolicyByUnique.plan se for igual à negociação removida
    const updatedBenefitsPolicyByUnique = benefitsPolicy.benefitsPolicyByUnique.plan === negotiationId
      ? { plan: undefined }
      : benefitsPolicy.benefitsPolicyByUnique;

    setCapitalInsured(updatedCapitalInsured);
    return setBenefitsPolicy({
      ...benefitsPolicy,
      negotiations: updatedNegotiations,
      benefitsPolicyByRole: updatedBenefitsPolicyByRole,
      benefitsPolicyByUnique: updatedBenefitsPolicyByUnique,
      benefitsPolicyByGeographicRegion: updatedBenefitsPolicyByGeographicRegion,
    });
  }

  return (
    <>
      <Container>
        <Title>Negociações</Title>
        {benefitsPolicy.negotiations.map(negotiation => (
          <div key={negotiation} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <TextField
              label={`Negociação ${negotiation}`}
              value={negotiation}
              disabled
            />
            <ButtonDelete color="error" onClick={() => handleRemoveNegotiation(negotiation)} />
          </div>
        ))}
        <Button onClick={handleAddNegotiation}>+ Adicionar</Button>
        <Row>
          <RadioCard
            label="Negociação global"
            selected={benefitsPolicy.type === "UNIQUE"}
            onClick={() => handleChangeRoles({ type: "UNIQUE" })}
          />
          <RadioCard
            label="Cargo"
            selected={benefitsPolicy.type === "ROLE"}
            onClick={() => handleChangeRoles({ type: "ROLE" })}
          />
          <RadioCard
            label="Região"
            selected={benefitsPolicy.type === "GEOGRAPHIC_REGION"}
            onClick={() => handleChangeRoles({ type: "GEOGRAPHIC_REGION" })}
          />
        </Row>
        {benefitsPolicy.type === "ROLE" && <BenefitsPolicyRole benefitsPolicy={benefitsPolicy} handleChange={handleChangeRoles} />}
        {benefitsPolicy.type === "UNIQUE" && <BenefitsPolicyUnique benefitsPolicy={benefitsPolicy} handleChange={handleChangeRoles} />}
        {benefitsPolicy.type === "GEOGRAPHIC_REGION" && <BenefitsPolicyRegion benefitsPolicy={benefitsPolicy} handleChange={handleChangeRoles} />}
      </Container>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          gap: "8px",
          marginTop: "50px",
        }}
      >
        <Button
            variant="contained"
            style={{
              paddingTop: "0.25rem",
              paddingBottom: "0.25rem",
              paddingLeft: "1rem",
              paddingRight: "1rem",
              borderRadius: "0.375rem",
              height: "2.5rem",
              fontSize: "0.875rem",
              lineHeight: "1.25rem",
              fontWeight: 600,
              width: "130px",
              marginLeft: "50px"
            }}
            onClick={handleSave}
          >
            {"Salvar"}
          </Button>
      </div>
    </>
  );
}
